// @codekit-prepend "_keyboard.js"
// @codekit-prepend "_collapsibles.js"
// @codekit-prepend "_focus-within-attr.js"
// @codekit-prepend "_nav-desktop.js"
// @codekit-prepend "_nav-mobile.js"
// @codekit-prepend "_toggle-menu.js"
// @codekit-prepend "_toggle-filter.js"
// @codekit-prepend "_overlay.js"
// @codekit-prepend "_products.js"
// @codekit-prepend "_license.js"
// @codekit-prepend "_table.js"
// @codekit-prepend "_slider.js"
// @codekit-prepend "_behaviors.js"

$(function () {
    'use strict'
    Keyboard.init();
    Collapsibles.init();
    ToggleMenu.init();
    ToggleFilter.init();
    Overlay.init();
    Products.init();
    License.init();
    // don't init Slider on load (Slider.init()) because it's ajax content;
    Table.init();
    FocusWithin.init();

    if ($('[data-behavior=toggle-menu]').css('display') === 'block') {
        NavMobile.init();
    } else {
        NavDesktop.init();
    }

    Behaviors.init();
});
